import React, { useEffect, useState } from "react";
import { drawPoint, drawLine, drawPolygon } from "./utils";

/** This component renders a legend for a map using a canvas element.
 * It fetches legend data from a given URL and draws the symbols on a canvas.
 */
const LegendCanvas = ({ url, configLayers }) => {
	const [legendData, setLegendData] = useState(null);

	useEffect(() => {
		setLegendData(null);
		fetch(url)
			.then((r) => r.json())
			.then((json) => setLegendData(json))
			.catch((err) => console.error("Error fetching legend:", err));
	}, [url]);

	if (!legendData) return <div>Loading legend...</div>;

	// To mask first rule polygon - this will be subtitle due to specific OSI legend
	const verifyPolygon = ({Polygon}) => {
		let createCanvas = true;
		if(!Polygon || !Polygon?.fill || typeof Polygon.fill !== 'string') {
			createCanvas = false
		}
		return createCanvas
	}

	/**
	 * will return the title of the layer from config.json file or the layer infos
	 * @param {any} layer from ol data
	 * @returns 
	 */
	const getLayerTitle = (layer) => {
		const layerConfig = configLayers?.filter(x => x?.params?.layers === layer.layerName)[0]
		return layerConfig?.title || layer.layerName || layer.layerName;
	}

	const renderCanvas = (symbolizer) => {
		const size = 40;
		const canvas = document.createElement("canvas");
		canvas.width = size;
		canvas.height = size;
		
		let ctx = canvas.getContext("2d");

		if (symbolizer.Point) {drawPoint(ctx, size, symbolizer.Point)}
		else if (symbolizer.Line) {drawLine(ctx, size, symbolizer.Line)}
		else if (symbolizer.Polygon) {drawPolygon(ctx, size, symbolizer.Polygon)}

		if(symbolizer.Polygon && !verifyPolygon(symbolizer)){
			return null;
		}

		return (
			<canvas
				ref={(el) => el && el.replaceWith(canvas)}
				style={{ width: "40px", height: "40px" }}
			/>
		);
	};

	const legendItems = (layer, idx) =>
		layer.rules.map((rule, i) => {
			const ruleTitle = rule.title || "Untitled";
			const symbolizer = rule.symbolizers?.[0];
			if (!symbolizer) return null;

			const graphic = symbolizer.Point?.graphics?.[0];
			let symbolElement;

			if (graphic?.["external-graphic-url"]) {
				symbolElement = (
					<img
						src={graphic["external-graphic-url"]}
						alt={ruleTitle}
						className="legend-image"
					/>
				);
			} else {
				symbolElement = renderCanvas(symbolizer);
			}

			return (
				<div key={`${idx}-${i}`} className="legend-item">
					{symbolElement}
					<span className={symbolElement ? "" : "subtitle"}>{ruleTitle}</span>
				</div>
			);
		});

	return (
		<div className="legend-container">
			{legendData.Legend.map((layer, idx) => (
				<div key={idx}>
					<span>{getLayerTitle(layer)}</span>
					{legendItems(layer, idx)}
				</div>
			))}
		</div>
	);
};

export default LegendCanvas;
